const h = {
  name: "Chip",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M30,10H10v20h20V10z M12,28V12h16v16H12z"/>
		<path class="st0" d="M19,4h-6V0h-2v4H4v7H0v2h4v6H0v2h4v6H0v2h4v7h7v4h2v-4h6v4h2v-4h6v4h2v-4h7v-7h4v-2h-4v-6h4v-2h-4v-6h4v-2h-4
			V4h-7V0h-2v4h-6V0h-2V4z M6,34V6h28v28H6z"/>
	</g>
</g>
</svg>
  `
};
export {
  h as Chip
};
